import { absolutePath } from "@/react/helpers/urlHelpers/internalApi/absolutePath";

export const imagePosts = {
  create: (spaceId: number) => absolutePath(`spaces/${spaceId}/images/posts`),
  update: (spaceId: number, postSlug: string) =>
    absolutePath(`spaces/${spaceId}/images/posts/${postSlug}`),
  duplicate: (spaceId: number, postSlug: string) =>
    absolutePath(`spaces/${spaceId}/images/posts/${postSlug}/duplicate`),
};
